export  const lowerCase = new RegExp('(?=.*[a-z])');
export const capitalCase = new RegExp('(?=.*[A-Z])');
export const numberCase = new RegExp('(?=.*[0-9])');
export const emailRegex = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);
export const specialChar = new RegExp(/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?!.*[`~<>,./?:;"'}{\[\]=+-]).{8,}$/);
export const getToken = () => {
    let token  = localStorage.getItem('token');
    return token;
}
